import { Typography } from '@gto/ui/typography'

import { toRate } from '@/utils/to-rate'

type TierTagProps = {
  tierName: string | null | undefined
  commissionRate: number | string | null | undefined
}

/**
 * Shared tier presentation for admin tables: a neutral chip followed by the
 * commission rate. Tier names are free-form strings with no colour config in
 * the product — every tier gets the same neutral treatment (no name-keyed
 * colour magic). Falls back to an em-dash when the partner has no tier
 * — that treatment is what the dashboard leaderboard expects. Call sites that
 * want a blank cell instead (the admin partners table is one) MUST guard for
 * `tierName == null` themselves and skip rendering `<TierTag>` entirely.
 */
export const TierTag = ({ tierName, commissionRate }: TierTagProps) => {
  if (tierName == null) {
    return (
      <Typography
        color="text.secondary"
        variant="body2"
      >
        —
      </Typography>
    )
  }

  const rate = commissionRate == null ? null : toRate(commissionRate, 'tier-tag commissionRate:')

  return (
    <span className="inline-flex items-center gap-2">
      <span className="inline-flex items-center rounded-full border border-divider bg-paper-elevation4 px-2 py-0.5 text-xs font-medium leading-100">
        {tierName}
      </span>
      {rate != null && (
        <Typography
          color="text.secondary"
          variant="caption"
        >
          {rate}%
        </Typography>
      )}
    </span>
  )
}
